import { render } from "./DsHeader.vue?vue&type=template&id=763f938a&scoped=true"
const script = {}

import "./DsHeader.vue?vue&type=style&index=0&id=763f938a&lang=scss&scoped=true"

import exportComponent from "/opt/gitea/webhooker/hooks/dscontrol/kraken/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763f938a"]])

export default __exports__